import { Link } from "react-router-dom";
import { movies, categories } from "@/mocks/movies";
import { useState } from "react";

export default function FeaturedMovies() {
  const [activeCategory, setActiveCategory] = useState("all");

  const filteredMovies =
    activeCategory === "all"
      ? movies
      : movies.filter((m) => m.categorySlug === activeCategory);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选电影
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            海量高清影片，总有一部适合你
          </p>
        </div>

        <div className="flex items-center justify-center gap-1 flex-wrap mb-10">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-500 bg-background-100 hover:bg-background-200"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
          {filteredMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 555电影网高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className="text-xs font-bold bg-accent-500 text-background-50 px-2 py-0.5 rounded-md whitespace-nowrap">
                    {movie.rating}
                  </span>
                </div>
                {movie.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded-md whitespace-nowrap">
                      新
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {movie.year} · {movie.category}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}